import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import MultipleSessionSssoPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const store = getStore();

const createMultipleSessionSsoPanelScreen = ({ continueUrl, switchUrl, newUser, current }) => {
  const domId = 'multipleSessionSsoPanel';
  if (isSupportedBrowser()) {
    ReactDOM.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <MultipleSessionSssoPanel
            continueUrl={continueUrl}
            switchUrl={switchUrl}
            newUser={newUser}
            current={current}
          />
        </AuthScreenLayout>
      </Provider>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createMultipleSessionSsoPanelScreen = createMultipleSessionSsoPanelScreen;
